import { hostBridge } from '@publicala/delfino';
import type { DictionaryLookupPayload, DictionaryResponse } from '@publicala/delfino';
import { DEFAULT_DICTIONARY_MOCK, isE2EMockActive } from '../../e2eMockGuard';

/**
 * Dictionary API for Volpe.
 * Provides methods to lookup word definitions via hostBridge.
 */
class DictionaryAPI {
    /**
     * Lookup word definition.
     * Returns mock data in E2E standalone mode.
     *
     * @param payload - Lookup parameters matching Delfino's DictionaryLookupPayload
     * @param payload.text - The word to look up
     * @param payload.lang - The language for the definition
     * @returns Dictionary response with word and entries
     */
    async lookup(payload: DictionaryLookupPayload): Promise<DictionaryResponse> {
        if (isE2EMockActive()) {
            return DEFAULT_DICTIONARY_MOCK;
        }
        return hostBridge.dictionary.lookup(payload);
    }
}

export const dictionaryAPI = new DictionaryAPI();
